module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/forli.081cae907a9b4d14263fe8779118b872.jpg";